import { KYC_STATUS } from "./kycStatus";

// ⚠️ TEMP DEV-PHASE PREVIEW — remove with the switcher and the AppContext seed.
//
// Lets the KYC states be walked through inside the real supplier app rather
// than on a mock page: `?kycPreview=1` turns it on (and it stays on while
// clicking between pages), `?kycPreview=0` turns it off. Opt-in only — nothing
// here runs for a real account unless that parameter was typed.

const FLAG_KEY = "kycPreview";
const STATUS_KEY = "kycPreviewStatus";

/** Reads the opt-in parameter, remembers it, and says whether preview is on. */
export const readKycPreviewFlag = () => {
  try {
    const param = new URLSearchParams(window.location.search).get("kycPreview");
    if (param === "1") localStorage.setItem(FLAG_KEY, "1");
    if (param === "0") {
      localStorage.removeItem(FLAG_KEY);
      localStorage.removeItem(STATUS_KEY);
    }
    return localStorage.getItem(FLAG_KEY) === "1";
  } catch {
    // Private mode / blocked storage — preview simply stays off.
    return false;
  }
};

export const getPreviewKycStatus = () => {
  try {
    // Opens where a real supplier opens: with Grow's form still to fill in.
    return localStorage.getItem(STATUS_KEY) || KYC_STATUS.DETAILS_REQUIRED;
  } catch {
    return KYC_STATUS.DETAILS_REQUIRED;
  }
};

export const setPreviewKycStatus = (status) => {
  try {
    localStorage.setItem(STATUS_KEY, status);
  } catch {
    // Nothing to do — the switcher still updates the live state.
  }
};
